// extracted by mini-css-extract-plugin
export default {"ExtraDetailGroup":"ExtraDetailGroup_ExtraDetailGroup__pM5S9","ExtraDetailName":"ExtraDetailGroup_ExtraDetailName__5ZIAZ","ExtraDetailItem":"ExtraDetailGroup_ExtraDetailItem__OzSoE"};